import script from "./call-center-boss.vue?vue&type=script&setup=true&lang=js"
export * from "./call-center-boss.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__